import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    editNameLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for the inline rename input for the folder */
            editNameLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderName.editNameLabel?c=3ojzyosg73nm4", defaultMessage: "Rename folder" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
